import { apiFetch } from './apiClient';



export const listarProcessos = (filtros = {}) => {
  const params = new URLSearchParams();
  if (filtros.cliente_id) params.set('cliente_id', filtros.cliente_id);
  if (filtros.tipo)       params.set('tipo', filtros.tipo);
  if (filtros.status)     params.set('status', filtros.status);
  const qs = params.toString();
  return apiFetch(`/processos${qs ? `?${qs}` : ''}`);
};

export const buscarProcesso = (id) => apiFetch(`/processos/${id}`);

export const criarProcesso = (dados) =>
  apiFetch('/processos', { method: 'POST', body: JSON.stringify(dados) });

export const atualizarProcesso = (id, dados) =>
  apiFetch(`/processos/${id}`, { method: 'PATCH', body: JSON.stringify(dados) });

export const editarProcesso = (id, dados) =>
  apiFetch(`/processos/${id}`, { method: 'PUT', body: JSON.stringify(dados) });

export const excluirProcesso = (id) =>
  apiFetch(`/processos/${id}`, { method: 'DELETE' });

export const reabrirProcesso = (id) =>
  apiFetch(`/processos/${id}/reabrir`, { method: 'POST' });

export const voltarEtapaProcesso = (id) =>
  apiFetch(`/processos/${id}/voltar-etapa`, { method: 'POST' });

export const concluirEtapaProcesso = (id, dados) =>
  apiFetch(`/processos/${id}/concluir-etapa`, { method: 'POST', body: JSON.stringify(dados) });

/* ── deep-link "abrir este processo" a partir de outro módulo (ex: aba
   Processos no drawer do Cliente) -- este app não usa URL com :id, as
   telas trocam por estado interno, então o alvo viaja pela sessionStorage
   até o módulo Processos consumir no mount. ── */
const CHAVE_DEEPLINK = 'processo_abrir_id';

export function irParaProcesso(id) {
  try { sessionStorage.setItem(CHAVE_DEEPLINK, id); } catch {}
}

export function consumirProcessoParaAbrir() {
  try {
    const id = sessionStorage.getItem(CHAVE_DEEPLINK);
    if (id) sessionStorage.removeItem(CHAVE_DEEPLINK);
    return id;
  } catch { return null; }
}
